export const CREATE_REVISION_START = 'CREATE_REVISION_START';
export const CREATE_UPDT_REVISION_SUCCESS = 'CREATE_UPDT_REVISION_SUCCESS';
export const CREATE_UPDT_REVISION_FAIL = 'CREATE_UPDT_REVISION_FAIL';
export const CREATE_UPDT_REVISION_PHASE_CHG = 'CREATE_UPDT_REVISION_PHASE_CHG';

export const UPDATE_REVISION_START = 'UPDATE_REVISION_START';
export const ADD_TIMEOUT_PAYLOAD = 'ADD_TIMEOUT_PAYLOAD';
export const UPDATE_TIMEOUT_STATUS = 'UPDATE_TIMEOUT_STATUS';
export const TAGS_PROG_BAR_STATUS = 'TAGS_PROG_BAR_STATUS';

export const LOADING = 'LOADING';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const INIT = 'INIT';

export const CREATE_DUPLICATELINE_START = 'CREATE_DUPLICATELINE_START';
export const CREATE_DUPLICATELINE_SUCCESS = 'CREATE_DUPLICATELINE_SUCCESS';
export const CREATE_DUPLICATELINE_FAIL = 'CREATE_DUPLICATELINE_FAIL';




